/* Ghorer Bazar theme — storefront JS.
   Cart uses Shopify AJAX API + Section Rendering API. UI carousels/menus ported from original template. */
(function () {
  "use strict";

  var routes = window.routes || {};
  var money = function (cents) {
    return "৳" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };

  /* ---------- Image placeholder fallback ---------- */
  var PLACEHOLDER = "data:image/svg+xml;utf8," + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><rect width="400" height="400" fill="#fff5ec"/><text x="200" y="210" font-family="sans-serif" font-size="20" fill="#f48721" text-anchor="middle">image unavailable</text></svg>'
  );
  document.addEventListener("error", function (e) {
    var t = e.target;
    if (t && t.tagName === "IMG" && !t.dataset.ph) { t.dataset.ph = "1"; t.src = PLACEHOLDER; }
  }, true);

  /* ---------- Cart (Shopify AJAX) ---------- */
  function getSectionsToRender() {
    return ["cart-drawer"]; // rendered via ?sections= against Section Rendering API
  }

  function fetchCart() {
    return fetch(routes.cart_url + ".js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function updateCartUI(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (n) { n.textContent = cart.item_count; });
    document.querySelectorAll("[data-cart-total]").forEach(function (n) { n.textContent = money(cart.total_price); });
    document.querySelectorAll("[data-subtotal]").forEach(function (n) { n.textContent = money(cart.total_price); });
    document.querySelectorAll("[data-grand-total]").forEach(function (n) { n.textContent = money(cart.total_price); });
  }

  function sectionList() {
    var s = ["cart-drawer"];
    if (document.querySelector("[data-cart-page-items]")) s.push("main-cart");
    return s.join(",");
  }

  function replaceFrom(html, selector) {
    var cur = document.querySelector(selector);
    if (!cur) return;
    var fresh = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    if (!fresh) return;
    var wasOpen = cur.classList.contains("open");
    cur.innerHTML = fresh.innerHTML;
    if (wasOpen) cur.classList.add("open");
  }

  function applySections(cart) {
    if (cart && cart.item_count != null) updateCartUI(cart);
    if (cart && cart.sections) {
      if (cart.sections["cart-drawer"]) replaceFrom(cart.sections["cart-drawer"], "#cartDrawer");
      if (cart.sections["main-cart"]) replaceFrom(cart.sections["main-cart"], ".cart-page");
    }
  }

  function addToCart(form) {
    var data = new FormData(form);
    data.append("sections", sectionList());
    data.append("sections_url", window.location.pathname);
    return fetch(routes.cart_add_url + ".js", { method: "POST", headers: { Accept: "application/json" }, body: data })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw res.body;
        if (res.body.sections) applySections(res.body);
        // add.js item response has no totals; fetch counts once for the header/float.
        fetchCart().then(updateCartUI);
        openCart();
      })
      .catch(function (err) {
        console.error(err);
        alert((err && err.description) || (window.cartStrings && window.cartStrings.error) || "Error adding to cart.");
      });
  }

  // Single request: change qty + get updated cart JSON + rendered sections together.
  function changeLine(key, quantity) {
    return fetch(routes.cart_change_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity, sections: sectionList(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (cart) { applySections(cart); return cart; });
  }

  /* ---------- Cart drawer open/close ---------- */
  var drawer, overlay;
  function openCart() {
    drawer = document.getElementById("cartDrawer");
    overlay = document.getElementById("overlay");
    if (!drawer) { window.location.href = routes.cart_url; return; }
    drawer.classList.add("open");
    if (overlay) overlay.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("open");
    if (overlay) overlay.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
  }

  function setupCart() {
    overlay = document.getElementById("overlay");

    document.body.addEventListener("submit", function (e) {
      var form = e.target.closest("[data-cart-add-form]");
      // Also catch Shopify {% form 'product' %} output, matched by its /cart/add action.
      if (!form) {
        var candidate = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
        if (candidate) form = candidate;
      }
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });

    document.body.addEventListener("click", function (e) {
      var buyNow = e.target.closest("[data-buy-now]");
      if (buyNow && !buyNow.disabled) {
        e.preventDefault();
        var bnForm = buyNow.closest("form");
        if (!bnForm) return;
        fetch(routes.cart_add_url + ".js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(bnForm) })
          .then(function () { window.location.href = routes.checkout_url || "/checkout"; })
          .catch(function () { window.location.href = routes.cart_url; });
        return;
      }

      var openBtn = e.target.closest("#cartButton, [data-open-cart]");
      if (openBtn && openBtn.tagName !== "A") { e.preventDefault(); openCart(); return; }
      if (openBtn && openBtn.tagName === "A" && drawer) { e.preventDefault(); openCart(); return; }

      var close = e.target.closest("#closeCart");
      if (close) { closeCart(); return; }

      var remove = e.target.closest("[data-cart-remove]");
      if (remove) { changeLine(remove.getAttribute("data-cart-remove"), 0); return; }

      var inc = e.target.closest("[data-cart-increase]");
      if (inc) { stepLine(inc, inc.getAttribute("data-cart-increase"), 1); return; }

      var dec = e.target.closest("[data-cart-decrease]");
      if (dec) { stepLine(dec, dec.getAttribute("data-cart-decrease"), -1); return; }
    });

    document.getElementById("overlay") && document.getElementById("overlay").addEventListener("click", closeCart);
  }

  // Read current qty from the DOM (no pre-fetch); optimistic update for instant feel; then one change request.
  function stepLine(btn, key, delta) {
    var stepper = btn.closest(".qty-stepper, .mini-qty");
    var display = stepper ? stepper.querySelector("strong, b") : null;
    var cur = display ? Number((display.textContent || "").trim()) || 1 : 1;
    var next = Math.max(0, cur + delta);
    if (display && next > 0) display.textContent = next; // optimistic
    changeLine(key, next);
  }

  /* ---------- Hero slider ---------- */
  function setupSlider() {
    var slides = Array.prototype.slice.call(document.querySelectorAll(".slide"));
    var dots = document.getElementById("sliderDots");
    if (!slides.length || !dots) return;
    var idx = 0;
    dots.innerHTML = slides.map(function (_, i) { return '<button aria-label="Slide ' + (i + 1) + '" data-dot="' + i + '"></button>'; }).join("");
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle("active", j === idx); });
      dots.querySelectorAll("button").forEach(function (d, j) { d.classList.toggle("active", j === idx); });
    }
    document.querySelectorAll("[data-slide]").forEach(function (b) {
      b.addEventListener("click", function () { show(idx + (b.dataset.slide === "next" ? 1 : -1)); });
    });
    dots.addEventListener("click", function (e) { var d = e.target.closest("[data-dot]"); if (d) show(Number(d.dataset.dot)); });
    show(0);
    setInterval(function () { show(idx + 1); }, 5500);
  }

  /* ---------- Draggable + carousels ---------- */
  function makeDraggable(track) {
    var down = false, startX, scrollLeft, moved = false;
    track.style.cursor = "grab";
    track.addEventListener("mousedown", function (e) { down = true; moved = false; track.style.cursor = "grabbing"; track.style.scrollBehavior = "auto"; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft; });
    ["mouseleave", "mouseup"].forEach(function (ev) { track.addEventListener(ev, function () { if (!down) return; down = false; track.style.cursor = "grab"; track.style.scrollBehavior = ""; }); });
    track.addEventListener("mousemove", function (e) { if (!down) return; e.preventDefault(); var x = e.pageX - track.offsetLeft; var walk = (x - startX) * 1.5; if (Math.abs(walk) > 5) moved = true; track.scrollLeft = scrollLeft - walk; });
    track.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  function setupCategoryCarousel() {
    document.querySelectorAll("[data-category-carousel]").forEach(function (c) {
      var track = c.querySelector("[data-category-track]"); var prev = c.querySelector("[data-category-prev]"); var next = c.querySelector("[data-category-next]");
      if (!track) return; makeDraggable(track);
      var step = function () { var card = track.querySelector(".category-card"); if (!card) return 240; var gap = parseFloat(getComputedStyle(track).columnGap || "16"); return card.getBoundingClientRect().width + gap; };
      prev && prev.addEventListener("click", function () { track.scrollBy({ left: -step() * 2, behavior: "smooth" }); });
      next && next.addEventListener("click", function () { track.scrollBy({ left: step() * 2, behavior: "smooth" }); });
    });
  }

  function setupProductCarousels() {
    document.querySelectorAll(".product-section [data-product-grid]").forEach(function (track) {
      if (track.dataset.carouselReady) return; track.dataset.carouselReady = "1";
      makeDraggable(track);
      var dots = document.createElement("div"); dots.className = "product-slider-dots"; track.insertAdjacentElement("afterend", dots);
      var metrics = function () { var card = track.querySelector(".product-card"); if (!card) return { step: 260, pages: 1 }; var gap = parseFloat(getComputedStyle(track).columnGap || "24"); var step = card.getBoundingClientRect().width + gap; var pages = Math.max(1, Math.ceil((track.scrollWidth - track.clientWidth) / step) + 1); return { step: step, pages: pages }; };
      var setActive = function () { var s = metrics().step; var a = Math.round(track.scrollLeft / s); dots.querySelectorAll("button").forEach(function (d, i) { d.classList.toggle("active", i === a); }); };
      var render = function () { var p = metrics().pages; dots.style.display = p > 1 ? "" : "none"; dots.innerHTML = Array.from({ length: p }, function (_, i) { return '<button type="button" aria-label="Slide ' + (i + 1) + '" data-product-dot="' + i + '"></button>'; }).join(""); setActive(); };
      var ticking = false;
      track.addEventListener("scroll", function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { setActive(); ticking = false; }); });
      dots.addEventListener("click", function (e) { var d = e.target.closest("[data-product-dot]"); if (!d) return; track.scrollTo({ left: Number(d.dataset.productDot) * metrics().step, behavior: "smooth" }); });
      window.addEventListener("resize", render); render();
    });
  }

  function setupBrandSlider() {
    var track = document.querySelector("[data-brand-track]"); if (!track) return; makeDraggable(track);
    var dots = document.createElement("div"); dots.className = "brand-dots"; track.insertAdjacentElement("afterend", dots);
    var step = function () { var card = track.querySelector(".brand-card"); if (!card) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap || "20"); return card.getBoundingClientRect().width + gap; };
    var pages = function () { return Math.max(1, Math.ceil((track.scrollWidth - track.clientWidth) / (step() * 4)) + 1); };
    var setActive = function () { var a = Math.round(track.scrollLeft / (step() * 4)); dots.querySelectorAll("button").forEach(function (d, i) { d.classList.toggle("active", i === a); }); };
    var render = function () { var p = pages(); dots.style.display = p > 1 ? "" : "none"; dots.innerHTML = Array.from({ length: p }, function (_, i) { return '<button type="button" data-brand-dot="' + i + '"></button>'; }).join(""); setActive(); };
    dots.addEventListener("click", function (e) { var d = e.target.closest("[data-brand-dot]"); if (d) track.scrollTo({ left: Number(d.dataset.brandDot) * step() * 4, behavior: "smooth" }); });
    var ticking = false; track.addEventListener("scroll", function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { setActive(); ticking = false; }); });
    window.addEventListener("resize", render); render();
  }

  /* ---------- Mobile menu + desktop dropdowns ---------- */
  function setupMobileMenu() {
    var panel = document.getElementById("mobileMenuPanel"); var ov = document.getElementById("overlay");
    var openers = document.querySelectorAll(".mobile-menu-toggle, [data-mobile-menu-open]");
    var close = document.querySelector(".mobile-menu-close");
    if (!panel || !openers.length) return;
    var show = function () { panel.classList.add("open"); panel.setAttribute("aria-hidden", "false"); ov && ov.classList.add("open"); };
    var hide = function () { panel.classList.remove("open"); panel.setAttribute("aria-hidden", "true"); ov && ov.classList.remove("open"); };
    openers.forEach(function (b) { b.addEventListener("click", show); });
    close && close.addEventListener("click", hide); ov && ov.addEventListener("click", hide);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") hide(); });
  }

  function setupDesktopDropdowns() {
    document.querySelectorAll(".gb-main-nav > ul > li.has-dropdown, .uf-nav > ul > li.has-dropdown").forEach(function (item) {
      item.addEventListener("mouseenter", function () { item.classList.add("is-open"); });
      item.addEventListener("mouseleave", function () { item.classList.remove("is-open"); });
      var trigger = item.querySelector(":scope > a");
      trigger && trigger.addEventListener("click", function (e) {
        if (window.innerWidth <= 1100) return;
        e.preventDefault();
        item.classList.toggle("is-open");
      });
    });
  }

  /* ---------- Predictive search ---------- */
  function setupSearch() {
    var wrap = document.querySelector("[data-predictive-search]"); if (!wrap) return;
    var input = wrap.querySelector("[data-predictive-search-input]");
    var results = wrap.querySelector("[data-predictive-search-results]");
    if (!input || !results || !routes.predictive_search_url) return;
    var timer;
    function run() {
      var term = input.value.trim();
      if (!term) { results.style.display = "none"; return; }
      fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=5&section_id=predictive-search")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var inner = doc.querySelector("[data-predictive-search-results]");
          results.innerHTML = inner ? inner.innerHTML : "";
          results.style.display = "block";
        }).catch(function () {});
    }
    input.addEventListener("input", function () { clearTimeout(timer); timer = setTimeout(run, 250); });
    input.addEventListener("focus", run);
    document.addEventListener("click", function (e) { if (!wrap.contains(e.target)) results.style.display = "none"; });
  }

  /* ---------- Mobile search toggle (icon -> form) ---------- */
  function setupSearchToggle() {
    var header = document.querySelector(".gb-header");
    var toggle = document.querySelector("[data-search-toggle]");
    if (!header || !toggle) return;
    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      header.classList.toggle("search-active");
      if (header.classList.contains("search-active")) {
        var input = header.querySelector("[data-predictive-search-input]");
        if (input) setTimeout(function () { input.focus(); }, 30);
      }
    });
    document.addEventListener("click", function (e) {
      if (!header.classList.contains("search-active")) return;
      if (e.target.closest(".gb-search") || e.target.closest("[data-search-toggle]")) return;
      header.classList.remove("search-active");
    });
  }

  /* ---------- Product page ---------- */
  function setupProductPage() {
    var root = document.querySelector("[data-product-detail]"); if (!root) return;
    var main = document.querySelector("[data-main-product-image]");
    var thumbs = document.querySelector("[data-product-thumbs]");
    function selectThumb(btn) { if (!btn || !main) return; main.src = btn.dataset.thumb; thumbs.querySelectorAll("button").forEach(function (b) { b.classList.toggle("active", b === btn); }); }
    thumbs && thumbs.addEventListener("click", function (e) { selectThumb(e.target.closest("[data-thumb]")); });
    function step(dir) { var btns = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll("button")) : []; if (!btns.length) return; var cur = btns.findIndex(function (b) { return b.classList.contains("active"); }); selectThumb(btns[(cur + dir + btns.length) % btns.length]); }
    var gp = document.querySelector("[data-gallery-prev]"), gn = document.querySelector("[data-gallery-next]");
    gp && gp.addEventListener("click", function () { step(-1); });
    gn && gn.addEventListener("click", function () { step(1); });

    var qty = document.querySelector("[data-product-qty]");
    var minus = document.querySelector("[data-qty-minus]"), plus = document.querySelector("[data-qty-plus]");
    minus && minus.addEventListener("click", function () { qty.value = Math.max(1, Number(qty.value || 1) - 1); });
    plus && plus.addEventListener("click", function () { qty.value = Number(qty.value || 1) + 1; });

    setupVariants(root, main, thumbs);
  }

  /* ---------- Variant switching (radio pills) ---------- */
  function setupVariants(root, main, thumbs) {
    var json = root.querySelector("[data-variant-json]");
    var idInput = root.querySelector("[data-variant-id]");
    if (!json || !idInput) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var addBtn = root.querySelector("[data-product-add]");
    var priceRegular = root.querySelector("[data-product-price] .price-item--regular, .detail-price .price-item--regular");
    var oldPrice = root.querySelector(".detail-price .old-price");
    var saveBadge = root.querySelector(".detail-price .price-save");

    function selectedOptions() {
      var picks = [];
      root.querySelectorAll("[data-option-position]").forEach(function (group) {
        var checked = group.querySelector(".variant-radio:checked");
        picks[Number(group.getAttribute("data-option-position")) - 1] = checked ? checked.value : null;
      });
      return picks;
    }

    function match(picks) {
      return variants.filter(function (v) {
        return picks.every(function (val, i) { return val == null || v.options[i] === val; });
      })[0];
    }

    function update() {
      var v = match(selectedOptions());
      if (!v) return;
      idInput.value = v.id;
      if (priceRegular) priceRegular.textContent = money(v.price);
      if (oldPrice) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          oldPrice.textContent = money(v.compare_at_price); oldPrice.style.display = "";
          if (saveBadge) { saveBadge.textContent = "Save " + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + "%"; saveBadge.style.display = ""; }
        } else {
          oldPrice.style.display = "none";
          if (saveBadge) saveBadge.style.display = "none";
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.classList.toggle("is-sold-out", !v.available);
      }
      if (v.featured_media && main) {
        main.src = v.featured_media.preview_image ? v.featured_media.preview_image.src : main.src;
        if (thumbs) {
          var t = thumbs.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          if (t) { main.src = t.dataset.thumb; thumbs.querySelectorAll("button").forEach(function (b) { b.classList.toggle("active", b === t); }); }
        }
      }
    }

    root.querySelectorAll(".variant-radio").forEach(function (r) { r.addEventListener("change", update); });
  }

  function setupProductTabs() {
    var btns = document.querySelectorAll("[data-tab]"); var contents = document.querySelectorAll(".tab-content");
    btns.forEach(function (b) {
      b.addEventListener("click", function () {
        btns.forEach(function (x) { x.classList.remove("active"); }); contents.forEach(function (c) { c.classList.remove("active"); });
        b.classList.add("active"); var t = document.getElementById("tab-" + b.dataset.tab); if (t) t.classList.add("active");
      });
    });
  }

  /* ---------- Collection filters ---------- */
  function setupCollapsibleFilters() {
    document.querySelectorAll(".filter-sidebar .filter-block").forEach(function (block) {
      var title = block.querySelector("h3"); if (!title) return;
      title.addEventListener("click", function () { block.classList.toggle("active"); });
    });
  }
  function setupMobileSidebar() {
    var sidebar = document.getElementById("filterSidebar"), trigger = document.getElementById("mobileFilterTrigger"), closeBtn = document.getElementById("closeSidebarBtn"), ov = document.getElementById("overlay");
    if (!sidebar || !trigger) return;
    var open = function () { sidebar.classList.add("open"); ov && ov.classList.add("active"); document.body.style.overflow = "hidden"; };
    var close = function () { sidebar.classList.remove("open"); ov && ov.classList.remove("active"); document.body.style.overflow = ""; };
    trigger.addEventListener("click", open); closeBtn && closeBtn.addEventListener("click", close); ov && ov.addEventListener("click", close);
  }
  function setupPriceRange() {
    var el = document.querySelector("[data-price-range]");
    if (!el) return;
    var min = el.querySelector("[data-range-thumb-min]");
    var max = el.querySelector("[data-range-thumb-max]");
    var fill = el.querySelector("[data-range-fill]");
    var lblMin = el.querySelector("[data-range-label-min]");
    var lblMax = el.querySelector("[data-range-label-max]");
    var fieldMin = el.querySelector("[data-range-field-min]");
    var fieldMax = el.querySelector("[data-range-field-max]");
    var MAX = Number(el.getAttribute("data-max")) || 0;
    if (!min || !max || !MAX) return;
    var GAP = Math.max(1, Math.round(MAX * 0.02));

    function render(active) {
      var a = Number(min.value), b = Number(max.value);
      if (a > b - GAP) {
        if (active === "min") { a = Math.max(0, b - GAP); min.value = a; }
        else { b = Math.min(MAX, a + GAP); max.value = b; }
      }
      a = Number(min.value); b = Number(max.value);
      var lp = (a / MAX) * 100, rp = (b / MAX) * 100;
      fill.style.left = lp + "%";
      fill.style.width = (rp - lp) + "%";
      lblMin.textContent = "Tk " + a.toLocaleString("en-US");
      lblMax.textContent = "Tk " + b.toLocaleString("en-US");
    }
    function commit() {
      fieldMin.value = min.value;
      fieldMax.value = max.value;
      fieldMin.dispatchEvent(new Event("change", { bubbles: true }));
    }
    min.addEventListener("input", function () { render("min"); });
    max.addEventListener("input", function () { render("max"); });
    min.addEventListener("change", commit);
    max.addEventListener("change", commit);
    render();
  }

  function setupFacets() {
    var form = document.querySelector("[data-facet-form]"); var sort = document.querySelector("[data-sort-by]");
    function submit() {
      var params = new URLSearchParams();
      if (form) new FormData(form).forEach(function (v, k) { if (v) params.append(k, v); });
      if (sort && sort.value) params.set("sort_by", sort.value);
      window.location.search = params.toString();
    }
    form && form.addEventListener("change", submit);
    sort && sort.addEventListener("change", submit);
  }

  /* ---------- Custom checkout page ---------- */
  function setupCustomCheckout() {
    var form = document.querySelector("[data-custom-checkout]");
    if (!form) return;
    var subCents = Number(form.getAttribute("data-subtotal-cents")) || 0;
    var deliveryEl = form.querySelector("[data-cc-delivery]");
    var totalEl = form.querySelector("[data-cc-total]");
    var currency = (totalEl.textContent.match(/[A-Z]{3}$/) || ["BDT"])[0];

    var fmt = function (cents) {
      return (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + " " + currency;
    };

    function charge() {
      var picked = form.querySelector('input[name="cc-area"]:checked');
      return picked ? Number(picked.getAttribute("data-charge")) * 100 : 0;
    }
    function render() {
      var d = charge();
      deliveryEl.textContent = fmt(d);
      totalEl.textContent = fmt(subCents + d);
    }
    form.querySelectorAll('input[name="cc-area"]').forEach(function (r) { r.addEventListener("change", render); });
    render();

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector(".cc-order-btn");
      if (btn) { btn.disabled = true; btn.classList.add("is-loading"); }

      var get = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ""; };
      var area = form.querySelector('input[name="cc-area"]:checked');
      var payment = form.querySelector('input[name="cc-payment"]:checked');

      var attributes = {};
      attributes[form.querySelector('[name="cc-name"]').closest(".cc-field").querySelector("span").textContent] = get("cc-name");
      attributes[form.querySelector('[name="cc-address"]').closest(".cc-field").querySelector("span").textContent] = get("cc-address");
      attributes[form.querySelector('[name="cc-phone"]').closest(".cc-field").querySelector("span").textContent] = get("cc-phone");
      if (area) attributes["Delivery Area"] = area.value;
      if (payment) attributes["Payment"] = payment.value;

      fetch(routes.cart_update_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: attributes, note: get("cc-note") })
      })
        .then(function () { window.location.href = "/checkout"; })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.classList.remove("is-loading"); }
          alert("Something went wrong. Please try again.");
        });
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    setupCart();
    setupSlider();
    setupCategoryCarousel();
    setupProductCarousels();
    setupBrandSlider();
    setupMobileMenu();
    setupDesktopDropdowns();
    setupSearch();
    setupSearchToggle();
    setupProductPage();
    setupProductTabs();
    setupCollapsibleFilters();
    setupMobileSidebar();
    setupPriceRange();
    setupFacets();
    setupCustomCheckout();
  });
})();
